(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("viewOrderDetails", {
        templateUrl: "app/public/viewOrderDetails.component.html",
        controller: ["publicResource", "messageService", "frameworkService", "$state", "$translate", ViewOrderDetailsCtrl],
        controllerAs: "vm"
    });
    function ViewOrderDetailsCtrl(publicResource, messageService, frameworkService, $state, $translate) {
        var vm = this;
        vm.orderGuid = $state.params.id;
        vm.dataLoaded = false;
        vm.frameworkData = frameworkService.data;
        publicResource.viewOrderDetails({ actionValue: vm.orderGuid }, function (result) {
            vm.order = result;
            if (vm.order.discountInfo && vm.order.discountInfo.code) {
                var desc = vm.order.discountInfo.isPercentage ? vm.order.discountInfo.value + "%" + $translate.instant("storefront.shoppingCart.discountCode.off") : "$" + vm.order.discountInfo.value + $translate.instant("storefront.shoppingCart.discountCode.off");
                vm.order.discountInfo.description = "[" + vm.order.discountInfo.code + " - " + desc + "]";
            }
            vm.dataLoaded = true;
        }, function (error) {
            messageService.error(error);
        });
        vm.print = function () {
            window.print();
        };
        vm.translateName = function (name, isCountry) {
            if (name) {
                if (isCountry)
                    return $translate.instant("common.country." + name.replace(/\s+/g, ''));
                return $translate.instant("common.stateProvince." + name.replace(/\s+/g, ''));
            }
            return "";
        };
    }
}());
